import { Apple } from "lucide-react";
import { APP_STORE_URL } from "@/config";

const VARIANTS = {
  primary:
    "bg-burgundy text-ivory-light border border-burgundy hover:bg-burgundy-hover hover:shadow-[0_10px_24px_rgba(110,22,51,0.22)]",
  outline:
    "bg-transparent text-burgundy border border-burgundy/40 hover:border-burgundy hover:bg-burgundy/5",
  light:
    "bg-ivory-light text-burgundy border border-ivory-light hover:bg-white hover:shadow-[0_10px_24px_rgba(0,0,0,0.18)]",
};

export default function AppStoreButton({ variant = "primary", className = "", testid = "appstore-cta" }) {
  return (
    <a
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      className={`inline-flex items-center gap-2.5 px-7 py-3.5 rounded-[3px] text-sm font-sans font-medium tracking-wide transition-all duration-300 ${VARIANTS[variant]} ${className}`}
    >
      <Apple className="w-4 h-4" aria-hidden="true" />
      <span>App Store&rsquo;da İndir</span>
    </a>
  );
}
